export default function getProgramEpisodeId(programEpisodeVersionId) {
    if (!programEpisodeVersionId) {
        return undefined;
    }
    const matched = programEpisodeVersionId.match(/^[\d]{7}-[\d]{3}/);
    if (matched && matched.length > 0) {
        return matched[0];
    }

    return undefined;
}
